// Quiz metadata: the parts that don't translate.
//
// Question + option text live in `public/locales/<lang>/onboarding.json` under
// `quiz.<role>.q<n>.question` + `quiz.<role>.q<n>.options[]`. The `correct`
// index here points at the position inside the options[] array, which is
// stable across locales (translators keep option order).
//
// See `src/hooks/useQuizQuestions.ts` for the consumer-facing API that merges
// these with the per-lang text.

export interface QuizQuestionMeta {
  id: number;
  correct: number;
  emoji: { correct: string; incorrect: string };
}

export interface QuizQuestion extends QuizQuestionMeta {
  question: string;
  options: string[];
}

// Chef-only now — the eater quiz was removed. New accounts register as eaters
// with no quiz; the only quiz left is the chef food-safety quiz, taken when an
// eater becomes a chef (chef-application modal or the end-of-publish gate).
export const quizMeta: Record<'chef', QuizQuestionMeta[]> = {
  chef: [
    { id: 1, correct: 1, emoji: { incorrect: '🍗', correct: '🧪' } },
    { id: 2, correct: 1, emoji: { incorrect: '✋️', correct: '🧼' } },
    { id: 3, correct: 2, emoji: { incorrect: '🧊', correct: '🍲' } },
  ],
};
